import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';

import { PacoteCampanhaLabelComponent } from './pacote-campanha-label.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PacoteCampanhaLabelComponent
    ],
    exports: [
        PacoteCampanhaLabelComponent
    ]
})
export class PacoteCampanhaLabelModule { }
